import React, { useEffect, useRef, useState } from 'react'
import './App.css'
import './EditEvent.css'
import { Redirect, useLocation, useHistory } from 'react-router-dom'
import Axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import { BiMenu } from 'react-icons/bi'
import { IoCheckmark, IoChevronBack } from 'react-icons/io5'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import { API_URL } from './config'

const baseURL = `${API_URL}/apps/kscanner/webservices.php`
const IS_STAGING = API_URL.toLowerCase() === 'https://stage.karamale.com'
const INVALID = { borderColor: '#c62f3e' }

const fmtDate = (d) => {
  const date = new Date(d)
  return isNaN(date)
    ? ''
    : date.toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' })
}

const Campaign = () => {
  const location = useLocation()
  const history = useHistory()
  const today = new Date().toISOString().split('T')[0]

  const [campaignExists, setCampaignExists] = useState('no')
  const [businessEmail, setBusinessEmail] = useState('')
  const [telephone, setTelephone] = useState(0)
  const [campaignname, setCampaignname] = useState('')
  const [campaigId, setCampaigId] = useState(0)
  const [keywords, setKeywords] = useState('')
  const [startdate, setStartdate] = useState('')
  const [enddate, setEnddate] = useState('')
  const [eventEndDate, setEventEndDate] = useState('')
  const [estBudget, setEstBudget] = useState(10.0)
  const [creditAmount, setCreditAmount] = useState(0)
  const [currentBudget, setCurrentBudget] = useState(0)
  const [saving, setSaving] = useState(false)
  const [spinning, setSpinning] = useState(false)
  const [published, setPublished] = useState(false)
  const [invalid, setInvalid] = useState('')
  const [toast, setToast] = useState(null) // { type: 'success' | 'error', msg }
  const toastTimer = useRef(null)

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState(isMobile)
  const [collapsed, setCollapsed] = useState(isMobile)

  const eventid = location.state?.eventid
  const eventname = location.state?.eventname
  const businessid = localStorage.getItem('businessid')

  const notify = (type, msg, ms = 4500) => {
    clearTimeout(toastTimer.current)
    setToast({ type, msg })
    toastTimer.current = setTimeout(() => setToast(null), ms)
  }

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  useEffect(() => {
    document.title = `${eventname} - Campaign`
    localStorage.setItem('ticket_type', 'digital')

    Axios.get(`${baseURL}?query=BUSINESSDETAILS&accountid=${businessid}`, { withCredentials: true })
      .then((response) => {
        setTelephone(response.data.phone)
        setBusinessEmail(response.data.email)
      })
      .catch((error) => console.log(error))

    Axios.get(`${baseURL}?query=ESTIMATED-BUDGET&event_id=${eventid}&business_id=${businessid}`, {
      withCredentials: true,
    })
      .then((response) => {
        setEstBudget(response.data.estedBudget.replace(/,/g, ''))
        setCreditAmount(1000000)
      })
      .catch((error) => console.log(error))

    Axios.get(`${baseURL}?query=CAMPAIGNESTIMATE&eventid=${eventid}&business_id=${businessid}`, {
      withCredentials: true,
    })
      .then((response) => {
        setCampaignExists(response.data.is_campaign_exist)
        setCurrentBudget(`${response.data.currentBudget}`)
        if (response.data.val === 1) {
          setCampaignname(response.data.campaign_name ?? response.data.eventName)
          setCampaigId(response.data.campaign_id)
          setKeywords(response.data.keywords)
          setStartdate(response.data.campaign_start_date ?? today)
          setEnddate(response.data.duration ?? response.data.eventEndDate)
          setEventEndDate(response.data.eventEndDate)
        } else {
          setCampaignname('')
          setKeywords('')
          setStartdate('')
          setEnddate('')
        }
      })
      .catch((error) => console.log(error))

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)
    return () => {
      window.removeEventListener('resize', updateIsMobile)
      clearTimeout(toastTimer.current)
    }
  }, [])

  const edit = (setter) => (e) => {
    setter(e.target.value)
    setInvalid('')
    setToast(null)
  }

  const fail = (field, msg) => {
    setInvalid(field)
    notify('error', msg)
  }

  const addPayment = (type) => {
    const budget = estBudget
    const campaign_id = campaigId

    if (!campaignname) return fail('campaign', 'Enter the campaign name.')
    if (!keywords)
      return fail('keywords', 'Enter keywords related to the event, separated by commas.')
    if (!startdate)
      return fail('startdate', "Choose a start date for the campaign. We suggest today's date.")
    if (!enddate)
      return fail('enddate', 'Choose an end date. Ideally match your event date or the day after.')
    if ((parseInt(budget) < 10 || budget === '' || budget === null) && type === 'launch') {
      return fail('', 'Budget should be at least R10.00.')
    }

    setInvalid('')

    if (type === 'save') {
      setSaving(true)

      const dataForm = new FormData()
      dataForm.append('eventid', eventid)
      dataForm.append('businessid', businessid)
      dataForm.append('campaign', campaignname)
      dataForm.append('keywords', keywords)
      dataForm.append('startdate', startdate)
      dataForm.append('enddate', enddate)
      dataForm.append('query', 'ADDCAMPAIGN')

      Axios({ method: 'POST', url: baseURL, data: dataForm, withCredentials: true })
        .then((response) => {
          setSaving(false)
          if (response.data.status === 'success') {
            notify('success', response.data.message)
            setCampaignExists('yes')
            setCampaignname(response.data.campaign_name)
            setCampaigId(response.data.campaign_id ?? campaigId)
            setKeywords(response.data.keywords)
            setStartdate(response.data.campaign_start_date)
            setEnddate(response.data.duration)
          } else {
            notify('error', response.data.message)
          }
        })
        .catch((error) => {
          setSaving(false)
          notify(
            'error',
            error.response?.data?.message || 'Could not save the campaign. Try again.',
          )
          console.log(error)
        })
      return
    }

    // launch
    setSpinning(true)
    const formData = new FormData()

    if (creditAmount > 0 || API_URL === 'https://stage.karamale.com') {
      formData.append('query', 'APPLY-CREDIT-FIRST-CAMPAIGN')
      formData.append('eventid', eventid)
      formData.append('budgetAmount', creditAmount)
      formData.append('campaignId', campaign_id)

      Axios({ method: 'POST', url: baseURL, data: formData, withCredentials: true })
        .then((response) => {
          setSpinning(false)
          if (response.data.status === 'success') {
            setPublished(true)
            notify('success', response.data.message)
          } else {
            setPublished(false)
            notify('error', response.data.message)
          }
        })
        .catch((error) => {
          setSpinning(false)
          setPublished(false)
          notify(
            'error',
            error.response?.data?.message || 'Could not publish the event. Try again.',
          )
          console.log(error)
        })
      return
    }

    const name = localStorage.getItem('businessname')
    formData.append('campaign_id', campaign_id)
    formData.append('item_name', campaignname + ' campaign')
    formData.append('amount', budget)
    formData.append('email', businessEmail)
    formData.append('cell_number', telephone)
    formData.append('name_first', name)
    formData.append('name_last', name)
    formData.append('eventid', eventid)
    formData.append('payment_method', 'cc')
    formData.append('businessid', businessid)
    formData.append('type', 'campaign')
    formData.append('is_mobile', 'yes')
    formData.append('category', 'campaign')

    fetch(`${API_URL}/apps/kscanner/payfast_credentials.php`, { method: 'POST', body: formData })
      .then((res) => res.json())
      .then((payData) => {
        const form = document.createElement('form')
        form.method = 'POST'
        form.action = 'https://www.payfast.co.za/eng/process'
        for (const [key, value] of Object.entries(payData)) {
          const input = document.createElement('input')
          input.type = 'hidden'
          input.name = key
          input.value = value
          form.appendChild(input)
        }
        document.body.appendChild(form)
        form.submit()
      })
      .catch((error) => {
        setSpinning(false)
        notify('error', 'Could not reach the payment provider. Try again.')
        console.log(error)
      })
  }

  if (localStorage.getItem('businessname') === null) {
    return <Redirect to="/login" />
  }

  const handleToggle = () => setCollapsed((prev) => !prev)

  // ---- derived state ----
  const saved = campaignExists === 'yes'
  const live = published || Number(currentBudget) > 0
  const chips = (keywords || '')
    .split(',')
    .map((k) => k.trim())
    .filter(Boolean)

  const s = new Date(startdate)
  const e = new Date(enddate)
  const ev = new Date(eventEndDate)
  const validRange = !isNaN(s) && !isNaN(e) && e >= s
  const days = validRange ? Math.round((e - s) / 864e5) + 1 : 0
  const coversEvent = !eventEndDate || (validRange && e >= ev)

  const steps = [
    {
      key: 'save',
      title: 'Save campaign details',
      hint: saved ? 'Details are saved' : 'Name, keywords and dates',
      done: saved,
    },
    {
      key: 'cover',
      title: 'Cover the whole event',
      hint: coversEvent ? 'Campaign runs through your event' : 'End date is before your event ends',
      done: saved && coversEvent,
    },
    {
      key: 'publish',
      title: 'Publish event',
      hint: live ? 'Your event is live' : 'Make it visible to buyers',
      done: live,
    },
  ]
  const doneCount = steps.filter((x) => x.done).length

  return (
    <div className="view">
      <Header />
      <SideNav collapsed={collapsed} onToggle={handleToggle} />

      <div
        className="main-content ee-page"
        style={{
          marginTop: 'var(--header-h)',
          marginLeft: isMob ? '0px' : collapsed ? '76px' : '252px',
        }}
      >
        {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}
        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        <div className="ee-topbar">
          <button type="button" className="ee-back" onClick={() => history.goBack()}>
            <IoChevronBack size={18} /> Back
          </button>
        </div>

        <div className="ee-grid">
          {/* ---------- Main column ---------- */}
          <div className="ee-main">
            <section className="ee-card">
              <div className="ee-card-head">
                <h2>Campaign details</h2>
              </div>
              <p className="ee-status-text">Publishing: {eventname}</p>

              <label className="ee-field">
                <span>Campaign name</span>
                <input
                  type="text"
                  className="ee-input"
                  style={invalid === 'campaign' ? INVALID : undefined}
                  placeholder="Enter campaign name"
                  value={campaignname || ''}
                  onChange={edit(setCampaignname)}
                />
              </label>

              <label className="ee-field">
                <span>Keywords</span>
                <input
                  type="text"
                  className="ee-input"
                  style={invalid === 'keywords' ? INVALID : undefined}
                  placeholder="music, live, johannesburg"
                  value={keywords || ''}
                  onChange={edit(setKeywords)}
                />
                <small className="ee-muted" style={{ display: 'block', marginTop: 6 }}>
                  Words people would search to find your event. Separate with commas.
                </small>
                {chips.length > 0 && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
                    {chips.map((k, i) => (
                      <span className="ee-chip" key={`${k}-${i}`}>
                        {k}
                      </span>
                    ))}
                  </div>
                )}
              </label>

              <div className="ee-form-grid">
                <div>
                  <label className="ee-field">
                    <span>Start date</span>
                    <input
                      type="date"
                      className="ee-input"
                      style={invalid === 'startdate' ? INVALID : undefined}
                      value={startdate || ''}
                      min={today}
                      onChange={edit(setStartdate)}
                    />
                  </label>
                </div>
                <div>
                  <label className="ee-field">
                    <span>End date</span>
                    <input
                      type="date"
                      className="ee-input"
                      style={invalid === 'enddate' ? INVALID : undefined}
                      value={enddate || ''}
                      min={eventEndDate || undefined}
                      onChange={edit(setEnddate)}
                    />
                  </label>
                </div>
              </div>
              <small className="ee-muted" style={{ display: 'block', marginTop: 8 }}>
                The end date must be on or after your event ends.
              </small>

              <div className="ee-actions">
                <button
                  type="button"
                  className="ee-btn ee-btn-primary"
                  onClick={() => addPayment('save')}
                  disabled={saving}
                >
                  {saving ? (
                    <ClipLoader color="#fff" size={16} />
                  ) : saved ? (
                    'Save changes'
                  ) : (
                    'Save campaign'
                  )}
                </button>
              </div>
            </section>
          </div>

          {/* ---------- Side column ---------- */}
          <aside className="ee-side">
            <section className="ee-card">
              <div className="ee-campaign-info">
                <span className={`ee-dot ${live ? 'is-live' : saved ? 'is-paused' : 'is-idle'}`} />
                <div>
                  <strong>
                    {live ? 'Your event is live' : saved ? 'Ready to publish' : 'Not saved yet'}
                  </strong>
                  <p>
                    {live
                      ? 'Your campaign is running and the event is published.'
                      : saved
                        ? 'Publish to make your event visible to buyers.'
                        : 'Save your campaign to unlock publishing.'}
                  </p>
                </div>
              </div>

              {validRange && (
                <p className="ee-empty" style={{ marginTop: 12 }}>
                  Runs {days} {days === 1 ? 'day' : 'days'}: {fmtDate(startdate)} to{' '}
                  {fmtDate(enddate)}
                </p>
              )}
              {!coversEvent && (
                <p className="ee-note ee-note-danger">
                  Your campaign ends before your event does. Move the end date to{' '}
                  {fmtDate(eventEndDate)} or later.
                </p>
              )}
              {IS_STAGING && (
                <p className="ee-note">Staging environment. No real payments are processed.</p>
              )}

              {live ? (
                <button
                  type="button"
                  className="ee-btn ee-btn-ghost"
                  style={{ width: '100%', marginTop: 16 }}
                  onClick={() => history.goBack()}
                >
                  Back to event
                </button>
              ) : (
                <button
                  type="button"
                  className="ee-btn ee-btn-primary"
                  style={{ width: '100%', marginTop: 16 }}
                  onClick={() => addPayment('launch')}
                  disabled={!saved || spinning || published}
                >
                  {spinning ? (
                    <ClipLoader color="#fff" size={16} />
                  ) : IS_STAGING ? (
                    'Publish event (staging)'
                  ) : (
                    'Publish event'
                  )}
                </button>
              )}
            </section>

            <section className="ee-card">
              <div className="ee-card-head">
                <h2>Before you publish</h2>
                <span className="ee-count">
                  {doneCount} of {steps.length}
                </span>
              </div>
              <div
                className="ee-progress"
                role="progressbar"
                aria-valuemin={0}
                aria-valuemax={steps.length}
                aria-valuenow={doneCount}
              >
                <span style={{ width: `${(doneCount / steps.length) * 100}%` }} />
              </div>

              <ol className="ee-steps">
                {steps.map((st, i) => (
                  <li key={st.key}>
                    <div
                      className={`ee-row ee-step ${st.done ? 'is-done' : ''}`}
                      style={{ cursor: 'default' }}
                    >
                      <span className="ee-step-mark">{st.done ? <IoCheckmark /> : i + 1}</span>
                      <span className="ee-row-text">
                        <span className="ee-row-title">{st.title}</span>
                        <span className="ee-row-hint">{st.hint}</span>
                      </span>
                    </div>
                  </li>
                ))}
              </ol>
            </section>
          </aside>
        </div>
      </div>

      {toast && (
        <div className={`ee-toast ee-toast-${toast.type}`} role="status">
          {toast.msg}
        </div>
      )}
    </div>
  )
}

export default Campaign
